import { render } from "./ComunicationTable.vue?vue&type=template&id=32a0d9d9"
import script from "./ComunicationTable.vue?vue&type=script&lang=js"
export * from "./ComunicationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__